<template>
<el-dialog title="提示" :visible.sync="centerDialogVisible" :close-on-click-modal='false' width="540px" left>
  <div class="bottom">

    <img src="@/assets/error.png" style="margin-top: 20px;" alt="404">
    <span class="text">
      {{tip}}
    </span>
  </div>

  <div class="bottom" style="  padding: 26px 20px 39px;">
    <el-button class="btn-check" @click="isClose">{{closeName}}</el-button>

  </div>
</el-dialog>
</template>

<script>

export default {
  data() {
    return {
      centerDialogVisible: false,

      closeName: '关闭',
      tip: '资源著录校验未通过，请修改后提交审核'

    };
  },
  mounted() {

  },
  methods: {
    isClose() {
      if (this.closeName === '重新上传') {
        this.$emit('tipAllChage')
      }
      this.centerDialogVisible = false;
    },
    isOpen(close, tip) {
      this.centerDialogVisible = true;
      this.closeName = close;
      this.tip = tip;

    },
    onsubmit() {
      this.centerDialogVisible = false;

    },

  },
}
</script>

<style lang="scss" scoped>
.text {

  font-size: 14px;
  margin-top: 17px;
  font-weight: 400;
  color: #1F233E;
  line-height: 24px;
}

.btn-check {
  width: 100px;
  height: 30px;
  background: #4C70E8;
  font-size: 14px;
  color: #ffffff;
  font-weight: bold;
  border-radius: 5px;
  padding: 0px;
}

.btn-off {
  width: 100px;
  height: 30px;
  background: #7B84A1;
  opacity: 0.5;
  border-radius: 5px;
  font-size: 14px;
  color: #ffffff;
  font-weight: bold;
  padding: 0px;
}

.bottom {

  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;

}

::v-deep .el-textarea__inner {
  padding: 5px 10px;
  resize: none;
  height: 30px !important;
  border-radius: 0px;
  font-size: 12px;
  background-color: #F9F9FC;
  border: 1px solid #DEE0E7 !important;
}

::v-deep .el-dialog__body {
  padding: 0px 10px 20px 10px;

}

::v-deep .el-dialog__header {
  padding: 15px 20px;
}

::v-deep .el-dialog__title {
  height: 20px;
  font-size: 20px;

  font-weight: bold;
  color: #4C70E8;

}

::v-deep .el-divider--horizontal {

  margin: 20px 0;
}
</style>
